import { makeAutoObservable } from 'mobx';
import { http, setToken, getToken, removeToken } from '../utils';
class LoginStore {
  token = getToken() || ''
  constructor () {
    makeAutoObservable(this);
  }
  
  getToken = async ({ username, passwd}) => {
    const res = await http.post('/api/user/login', { username, passwd });
    this.token = res.data.token;
    setToken(this.token);
  }
  
  logout = async () => {
    await http.post('/api/user/logout');
    this.token = '';
    removeToken();
  }
}

export default LoginStore;